import React, { useState, useEffect, useContext } from "react";
import Modal from "react-modal";
import DeleteIcon from "@material-ui/icons/Delete";
import { CircularProgress } from "@material-ui/core";
import { makeStyles, Typography, Button } from "@material-ui/core";
import { ThemeContext } from "../Context/Theme";

const useStyles = makeStyles({
  mymodal: {
    color: "black",
    position: "fixed",
    top: "50%",
    zIndex: 200,
    left: "50%",
    minWidth: "400px !important",
    transform: "translate(-50%, -50%)",
    display: "flex",
    flexDirection: "column",
    border: "1px solid #ccc",
    background: "#fff",
    overflow: "auto",
    borderRadius: "4px",
    outline: "none",
    padding: "20px",
  },
  myoverlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(78, 77, 77, 0.55)",
  },
  authRow: {
    display: "flex",
    justifyContent: "space-evenly",
  },
  authHeading: {
    fontSize: "20px !important",
    fontWeight: "500 !important",
    marginBottom: "20px !important",
    marginTop: "50px",
  },
  authOtpBtn: {
    marginTop: "20px",
    height: "45px",
    borderRadius: "4px",
    width: "40%",
    color: "white",
  },
});

const ConfirmationModal = ({
  open,
  content,
  deleteHandler,
  item,
  val,
  setIsopen,
  buttonName,
}) => {
  const dark = useContext(ThemeContext).dark;
  const styles = useStyles(dark);

  const [isOpen, setisOpen] = useState(open);
  const [loading, setLoading] = useState(false);

  function toggleModal() {
    setIsopen({
      open: false,
    });
    setisOpen(!isOpen);
  }
  useEffect(() => {
    setisOpen(open);
  }, [open]);

  return (
    <>
      <Modal
        isOpen={isOpen}
        ariaHideApp={false}
        onRequestClose={toggleModal}
        contentLabel="My dialog"
        className={styles.mymodal}
        overlayClassName={styles.myoverlay}
        closeTimeoutMS={50}
      >
        <div className={styles.authRow}>
          <Typography className={styles.authHeading}>{content}</Typography>
        </div>
        <br></br>
        <div className={styles.authRow}>
          <Button
            data-testid="block_user_btn"
            variant="contained"
            color="secondary"
            startIcon={!buttonName && <DeleteIcon />}
            className={styles.authOtpBtn}
            onClick={() => {
              if (val === undefined) {
                deleteHandler(item);
              } else {
                deleteHandler(item, val);
              }

              toggleModal();
            }}
          >
            {loading ? (
              <CircularProgress color="inherit" size={22} />
            ) : buttonName ? (
              buttonName
            ) : (
              "Delete"
            )}
          </Button>

          <Button
            data-testid="block_cancel_user_btn"
            onClick={toggleModal}
            variant="contained"
            color="primary"
            className={styles.authOtpBtn}
          >
            Cancel
          </Button>
        </div>
      </Modal>
    </>
  );
};

export default ConfirmationModal;
